import { combineReducers } from "redux";
import authReducer from "./authReducers";
import errorReducer from "./errorReducers";
import libraryPopups from "./popups";

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  libraryPopups: libraryPopups
});